module.exports = __webpack_public_path__ + "img/type_date_icon.648fc126.svg";